import { TemplateRef } from '@angular/core';

export interface GenericTableConfig {
  withoutHeader: boolean;
  emptyStateTitle: string;
  emptyStateDescription: string;
  isDraggable: boolean;
  withFooterRow: boolean;
}

export const GENERIC_TABLE_COMPONENT_DEFAULT_CONFIG: GenericTableConfig = {
  withoutHeader: false,
  emptyStateTitle: 'select-a-different-value-and-search-again',
  emptyStateDescription: 'select-other-values-and-search-again',
  isDraggable: false,
  withFooterRow: false,
};

export type GenericTableColumnContentType = 'value' | 'template';

export enum GenericTableColumnTheme {
  LIGHT = 'theme-light',
  FILLED = 'theme-filled',
}

type Overflow = 'visible' | 'hidden' | 'clip' | 'scroll' | 'auto';
type Align = 'start' | 'end' | 'left' | 'right' | 'center' | 'justify' | 'match-parent' | 'justify-all';

export class GenericTableColumn {
  static CONTENT_TYPE_VALUE: GenericTableColumnContentType = 'value';
  static CONTENT_TYPE_TEMPLATE: GenericTableColumnContentType = 'template';

  private header: string;
  private width: string;
  private template: TemplateRef<any>;
  private contentType: GenericTableColumnContentType = GenericTableColumn.CONTENT_TYPE_VALUE;
  private overflow: Overflow = 'visible';
  private align: Align;
  private footerCellTemplate: TemplateRef<any>;

  constructor(private readonly name: string) {}

  getWidth(): string {
    return this.width;
  }

  setWidth(value: string): GenericTableColumn {
    this.width = value;
    return this;
  }

  getHeader(): string {
    return this.header || this.name;
  }

  setHeader(value: string): GenericTableColumn {
    this.header = value;
    return this;
  }

  setTemplate(template: TemplateRef<any>): GenericTableColumn {
    this.template = template;
    this.contentType = GenericTableColumn.CONTENT_TYPE_TEMPLATE;
    return this;
  }

  getTemplate(): TemplateRef<any> {
    return this.template;
  }

  getName(): string {
    return this.name;
  }

  getContentType(): GenericTableColumnContentType {
    return this.contentType;
  }

  setOverflow(overflow: Overflow): GenericTableColumn {
    this.overflow = overflow;
    return this;
  }

  getOverflow(): string {
    return this.overflow;
  }

  setAlign(align: Align): GenericTableColumn {
    this.align = align;
    return this;
  }

  getAlign(): Align {
    return this.align;
  }

  withNoHeader(): GenericTableColumn {
    this.setHeader(' ');
    return this;
  }

  setFooterCellTemplate(template: TemplateRef<any>): GenericTableColumn {
    this.footerCellTemplate = template;
    return this;
  }

  getFooterColumnTemplate(): TemplateRef<any> {
    return this.footerCellTemplate;
  }
}

export class GenericTableRowMeta<T> {
  static KEY = '_generic_table_meta';

  constructor(private rowStyles: Record<string, unknown>) {}

  getMeta(): Record<string, { rowStyle: Record<string, unknown> }> {
    return {
      [GenericTableRowMeta.KEY]: {
        rowStyle: this.rowStyles,
      },
    };
  }
}
